import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FlowEngineSection from "./FlowEngineSection";
import { isFlowEngineEnabledForProcess } from "../../app/helpers/flowEngineConfigHelper";
import useActiveSpecialistRole from "../../app/hooks/useActiveSpecialistRole";
import "./flowListSelectionBar.css";

const ListFlowEngineToolbar = ({
  moduleProcess,
  moduleName,
  records = [],
  selectedIds = [],
  onAfterAction,
  onSelectionChange,
  pageCount = 0,
  totalAssigned = null,
  flowFilterActive = false,
  canSelectRecord = null
}) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const { canViewFlow } = useActiveSpecialistRole();
  const engineEnabled = isFlowEngineEnabledForProcess(configuration, moduleProcess);

  if (!engineEnabled || !canViewFlow) {
    return null;
  }

  const selectableRecords = typeof canSelectRecord === "function"
    ? records.filter((row) => canSelectRecord(row))
    : records;
  const selectedRecords = records.filter((row) => selectedIds.includes(row.id));
  const activeRecord = selectedRecords.length === 1 ? selectedRecords[0] : (selectedRecords[0] || null);
  const safePageCount = pageCount ?? records.length ?? 0;
  const safeTotalAssigned = totalAssigned ?? safePageCount;
  const selectedOnPage = records.filter((row) => selectedIds.includes(row.id)).length;
  const allPageSelected = selectableRecords.length > 0
    && selectableRecords.every((row) => selectedIds.includes(row.id));

  const handlePageSelection = () => {
    if (allPageSelected) {
      onSelectionChange?.([]);
      return;
    }
    onSelectionChange?.(selectableRecords.map((row) => row.id));
  };

  return (
    <div className="mb-3">
      <div className="flow-list-selection-bar">
        <div className="flow-list-selection-bar__left">
          <span className="flow-list-selection-bar__count">
            <i className="fa fa-check-square" aria-hidden="true" />
            <strong>{t("general.flow-engine.selected-label", "Seleccionados:")}</strong>
            {" "}
            {selectedOnPage}
            {" / "}
            {safePageCount}
          </span>
          {selectableRecords.length > 0 && (
            <button
              type="button"
              className="flow-list-selection-bar__action"
              onClick={handlePageSelection}
            >
              {allPageSelected
                ? t("general.flow-engine.deselect-page", "Deseleccionar")
                : t("general.flow-engine.select-page", "Seleccionar página")}
            </button>
          )}
        </div>
        {flowFilterActive && (
          <div className="flow-list-selection-bar__right">
            <span className="flow-list-selection-bar__tray">
              <strong>{t("general.flow-engine.tray-total-label", "Total en bandeja:")}</strong>
              {" "}
              {safeTotalAssigned}
            </span>
          </div>
        )}
      </div>
      <FlowEngineSection
        record={activeRecord}
        moduleProcess={moduleProcess}
        moduleName={moduleName}
        selectedRecords={selectedRecords}
        onAfterAction={onAfterAction}
        poolSurface="list"
      />
    </div>
  );
};

ListFlowEngineToolbar.propTypes = {
  moduleProcess: PropTypes.string.isRequired,
  moduleName: PropTypes.string,
  records: PropTypes.array,
  selectedIds: PropTypes.array,
  onAfterAction: PropTypes.func,
  onSelectionChange: PropTypes.func,
  pageCount: PropTypes.number,
  totalAssigned: PropTypes.number,
  flowFilterActive: PropTypes.bool,
  canSelectRecord: PropTypes.func
};

export default ListFlowEngineToolbar;
